<h5 class="cursor-pointer underline-hover mt-3">Aggiungi Oggetto di riferimento <i class="fa fa-plus"></i></h5><!-- (click)="openRelatedModal()" -->
<select name="related_select" id="related_select" class="form-control" (change)="addRelated($event)">
    <option value="">-</option>
    <option [value]="obj.public_token" *ngFor="let obj of getObjects(); index as i">{{ obj.configuration?.title || obj.name }}</option>
</select>
<div class="row">
    <div class="col">
        <div class="table-responsive-md">
            <table class="table">
                <thead class="thead-primary">
                    <tr>
                        <th scope="col">Titolo</th>
                        <th scope="col">Elimina</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="cursor-pointer" *ngFor="let obj of blog.configuration?.related_objects; index as i">
                        <td scope="col">{{ getObjects(obj)[0]?.configuration?.title || getObjects(obj)[0]?.name }}</td>
                        <td scope="col"><button class="btn btn-danger" (click)="blog.configuration?.related_objects?.splice(i, 1)"><i class="fa fa-trash"></i></button></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!--
<span id="relatedObjectModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog" style="overflow-y: scroll;">
        <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Articolo correlato</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeRelatedModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <input type="text" class="form-control" name="paragrafo_title" placeholder="Titolo del paragrafo" [(ngModel)]="paragrafo_model.title">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <ckeditor [editor]="Editor" [(ngModel)]="paragrafo_model.description" name="paragrafo_description" id="paragrafo_description"></ckeditor>
                            </div>
                        </div>

                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-primary" (click)="handleParagrafo()">{{ !!paragrafo_model.id ? 'Aggiorna' : 'Aggiungi' }}</button>
                    <button type="button" class="btn btn-outline-danger float-left" (click)="openParagrafoDeleteModal(paragrafo_model)" [hidden]="!paragrafo_model.id">Elimina</button>
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" (click)="closeRelatedModal()">Chiudi</button>
                </div>
            </div>
        </div>
    </div>
</span>

<span id="deleteRelatedObjectModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Conferma</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeParagrafoDeleteModal()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                Sei sicuro di voler eliminare questo paragrafo?
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" (click)="deleteParagrafo()">Elimina</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeParagrafoDeleteModal()">Chiudi</button>
            </div>
          </div>
        </div>
    </div>
</span>-->